module.exports = __webpack_public_path__ + "static/media/diagram_03.8a64ab55.svg";